export class MeasurementUnitDto {
    id!: number;
    name!: string;
    abbreviation!: string;
}
